export const SELECT_PRODUCT_MODEL = 'SELECT_PRODUCT_MODEL'
export const SELECT_SEARCH_PRODUCT_MODEL = 'SELECT_SEARCH_PRODUCT_MODEL'
export const UPDATE_PRODUCT_MODELS_LIST = 'UPDATE_PRODUCT_MODELS_LIST'
export const UPDATE_SEARCH_PRODUCT_MODELS_LIST = 'UPDATE_SEARCH_PRODUCT_MODELS_LIST'
export const SET_PRODUCT_MODEL_LOADING_STATE = 'SET_PRODUCT_MODEL_LOADING_STATE'
export const SET_PRODUCT_MODEL_COUNTS = 'SET_PRODUCT_MODEL_COUNTS'
export const SET_PRODUCT_MODEL_COUNTS_LOADING_STATE = 'SET_PRODUCT_MODEL_COUNTS_LOADING_STATE'
